<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroKit />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroKit from "../Components/Cadastros/CadastroKit.vue";
export default {
  name: "RegisterHotel",
  components: {
    CadastroKit,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
